import React from 'react';
import MobileProductCard from './MobileProductCard';
import MobileProductFeedback from './MobileProductFeedback';

export default function MobileProductsList({
  products,
  loading,
  refreshing,
  error,
  onRetry,
  selectedIds,
  ...actions
}) {
  return (
    <section className='mp-products-list' aria-label='Список товарів' aria-busy={loading || refreshing}>
      <MobileProductFeedback loading={loading} error={error} onRetry={onRetry} />
      {!loading && !error && !products.length && (
        <div className='mp-empty'>
          <h2>Товарів не знайдено</h2>
          <p>Змініть пошук або скиньте фільтри.</p>
        </div>
      )}
      {products.map(product => (
        <MobileProductCard
          key={product.id}
          product={product}
          selected={selectedIds.includes(product.id)}
          {...actions}
        />
      ))}
    </section>
  );
}
